import styled from "styled-components";
import {LinkToOfferBoxBase} from "../link-to-offer-base/link-to-offer-box-base";

export const LinkToOfferDialogCloseDefaultBox = styled(LinkToOfferBoxBase)`
    z-index:201;
`;
